var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.58203,
    y: 6.5,
    width: 27,
    height: 27,
    stroke: "#737478",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58203,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.582,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58203,
    y: 4.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.582,
    y: 4.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 11,
    width: 17.9898,
    height: 17.9898,
    fill: "white",
    stroke: "#F87B0E",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notch.82d44bfcf46329033015936ed0e33552.svg";